import { Command, CommandEnum, ChangeCoatingCommand } from './CommandModule';

export class ChangeCoatingsCommand  extends Command
{
    // Command list to execute and undo
    private _subCommands: Array<Command> = [];
        
    constructor(entityHangtypeAndUsemtlArray: Array<any>, coatingResource: any) {
        super();
        // Parse all entity array passed to the constructor
        for (let i = 0; i < entityHangtypeAndUsemtlArray.length; i++) {
            // And create a delete entity command for each of them
            this._subCommands.push(new ChangeCoatingCommand(entityHangtypeAndUsemtlArray[i].entity, coatingResource, entityHangtypeAndUsemtlArray[i].hangType, entityHangtypeAndUsemtlArray[i].usemtlName));
        }
    }

    name(): string {
        return CommandEnum.ChangeCoatingsCommand;
    }

    // Undo the current command
    undo() {
        // Parse all commands created by the constructor and undo them all
        for (let i = 0; i < this._subCommands.length; i++) {
            this._subCommands[i].undo();
        }

        //Execute parent function
        super.undo();
    }

    // Execute current command (redo)
    execute() {
        // Parse all commands created by the constructor and execute them all
        for (let i = 0; i < this._subCommands.length; i++) {
            this._subCommands[i].execute();
        }

        //Execute parent function
        super.execute();
    }
};
